// src/components/common/UI/CircularProgress.js
import React from 'react';
import './CircularProgress.css';

const CircularProgress = ({ percentage, size = 80, strokeWidth = 8, color = '#15A759' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="circular-progress" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="progress-ring">
        {/* Background circle */}
        <circle
          className="progress-ring-circle-bg"
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        {/* Progress circle */}
        <circle
          className="progress-ring-circle"
          stroke={color}
          strokeWidth={strokeWidth}
          fill="transparent"
          r={radius}
          cx={size / 2}
          cy={size / 2}
          style={{
            strokeDasharray: `${circumference} ${circumference}`,
            strokeDashoffset: offset,
          }}
        />
      </svg>
      <div className="progress-text">
        <span className="progress-percentage">{Math.round(percentage)}%</span>
      </div>
    </div>
  );
};

export default CircularProgress;